import api from '../../../api/apibackend';
import Nprogress from 'nprogress';
import Vue from 'vue';
import { FETCH_START, FETCH_END, SET_PLANS } from './mutation.types';
import { GET_PLANS, GET_SINGLE_PLAN, SEND_PLAN_PAYMENT } from './action.types';

const state = {
  plans: [],
  loading: [],
  accounts: [],
  dollar_rate: 1
}

const getters = {
  plans: state => state.plans,
  loadingPlans: state => state.loading,
  planDollarRate: state => state.dollar_rate,
  planPaymentAccounts: state => state.accounts
}

const mutations = {
  [FETCH_START](state) {
    Nprogress.start()
    state.loading = true
  },
  [FETCH_END](state) {
    Nprogress.done()
    state.loading = false
  },
  [SET_PLANS](state, {plans, dollar_rate, accounts}) {
    state.plans = plans;
    state.dollar_rate = dollar_rate;
    state.accounts = accounts;
  }
}

const actions = {
  async [GET_PLANS]({ commit, dispatch }) {
    try {
      commit(FETCH_START)
      
      const res = await api.get(`plans`)
      commit(SET_PLANS, res.data)
     
      commit(FETCH_END)
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
    }
  },
  async [SEND_PLAN_PAYMENT]({commit}, body) {
    try {
      const res = await api.post('payments/payments', body)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: `✔️ Pago enviado`
      })
    } catch(e) {
      console.table(err)
      Vue.notify({
          group: 'loggedIn',
          type: 'error',
          text: err.message
      })
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
